import { template as template_91299a8ba746439fb7445327313094aa } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { modifier } from 'ember-modifier';
import { provide, consume } from 'ember-provide-consume-context';
import { eq } from '@cardstack/boxel-ui/helpers';
import { CardContextName, DefaultFormatsContextName, CardURLContextName, GetCardContextName, GetCardsContextName, GetCardCollectionContextName, ResolvedCodeRef, type getCard, type getCards, type getCardCollection } from '@cardstack/runtime-common';
import type { BaseDef, Format, Field, CardContext } from 'https://cardstack.com/base/card-api';
interface Signature {
    Element: any;
    Args: {
        card: BaseDef;
        format?: Format;
        field?: Field;
        codeRef?: ResolvedCodeRef;
        displayContainer?: boolean;
    };
}
export default class CardRenderer extends Component<Signature> {
    @consume(GetCardContextName)
    private getCard: getCard;
    @consume(GetCardsContextName)
    private getCards: getCards;
    @consume(GetCardCollectionContextName)
    private getCardCollection: getCardCollection;
    @consume(CardContextName)
    private cardContext: CardContext;
    @tracked
    private headMarkup = '';
    @provide(DefaultFormatsContextName)
    get defaultFormat() {
        let { format } = this.args;
        format = format ?? 'isolated';
        return {
            cardDef: format,
            fieldDef: format
        };
    }
    @provide(CardURLContextName)
    private get cardURL() {
        return 'id' in this.args.card ? (this.args.card?.id as string | undefined) : undefined;
    }
    captureHeadMarkup = modifier((element: HTMLElement)=>{
        this.headMarkup = element.innerHTML.trim();
    });
    setHeadPreview = modifier((element: HTMLElement, [markup]: [string])=>{
        element.textContent = markup ?? '';
    });
    static{
        template_91299a8ba746439fb7445327313094aa(`
    {{! TODO: replace this hackish HTML preview in CS-9782 }}
    {{#if (eq @format 'head')}}
      <div hidden aria-hidden='true' {{this.captureHeadMarkup}}>
        <this.renderedCard @displayContainer={{false}} />
      </div>
      <pre {{this.setHeadPreview this.headMarkup}}></pre>
    {{else}}
      <this.renderedCard
        @displayContainer={{@displayContainer}}
        ...attributes
      />
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    get renderedCard() {
        return this.args.card.constructor.getComponent(this.args.card, this.args.field, this.args.codeRef ? {
            componentCodeRef: this.args.codeRef
        } : undefined);
    }
}
